export const UPDATE_FILTER = 'UPDATE_FILTER';
export const UPDATE_ORDER_BY = 'UPDATE_ORDER_BY';
export const UPDATE_SEARCH_QUERY = 'UPDATE_SEARCH_QUERY';
export const FETCH_ALCATRAZ = 'FETCH_ALCATRAZ';
export const RECEIVE_ALCATRAZ = 'RECEIVE_ALCATRAZ';
export const RECEIVE_ERROR = 'RECEIVE_ERROR';
export const LOAD_ALCATRAZ = 'LOAD_ALCATRAZ';



/** WEBPACK FOOTER **
 ** ./client/constants/ActionTypes.ts
 **/